import { LoadingOutlined } from "@ant-design/icons";
import IntlMessages from "@iso/components/utility/intlMessages";
import { Spin } from "antd";

export function ModalActions({
  disabled,
  submitText,
  cancelText,
  onSubmitAction,
  onCancelAction,
  loading,
}) {
  const antIcon = <LoadingOutlined spin />;
  return (
    <div className="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-10">
      {onSubmitAction && (
          <button
            type="submit"
            disabled={disabled}
            onClick={onSubmitAction}
            className="inline-flex w-full justify-center px-3 py-2 text-sm font-semibold text-primary disabled:text-gray-200  sm:ml-3 sm:w-auto"
          >
            {loading && <Spin indicator={antIcon} />}
            {!loading && <span>{submitText}</span>}
          </button>
      )}
      <button
        type="button"
        onClick={onCancelAction}
        className="mt-3 inline-flex w-full justify-center px-3 py-2 text-sm font-semibold text-gray-500 sm:mt-0 sm:w-auto"
      >
        {cancelText ?? <IntlMessages id="cancel" />}
      </button>
    </div>
  );
}
